import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import Modal, { setAppElement } from "react-modal";

import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import { getDate } from "date-fns";
import html2pdf from "html2pdf.js";

const GoodsReturnInvoiceLisview = (props) => {
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);

    const id = data && data.goodsReturnInvoiceId;
    if (id) {
      getGoodsReturnInvoice(
        {
          url: `/api/goodsReturnInvoice/?orgId=${localStorage.getItem(
            "orgId"
          )}&goodsReturnInvoiceId=${id}`,
        },
        (res) => {
          if (res) {
            //console.log(res);
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);

  const [goodsReturnInvoiceId, setGoodsReturnInvoiceId] = useState([]);
  const [docurl, setDocUrl] = useState(false);

  const { sendRequest: getGoodsReturnInvoice } = useHttp();
  const [allData, setAllData] = useState([]);

  const getData = () => {
    getGoodsReturnInvoice(
      {
        url: "/api/goodsReturnInvoice/",
      },
      (res) => {
        if (res) {
          //console.log(res);
          const sortedData = res.sort(
            (a, b) => b.goodsReturnInvoiceId - a.goodsReturnInvoiceId
          );

          setData(sortedData);

          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.docNo.includes(filetrtext) ||
        item.vendorName.includes(filetrtext) ||
        item.grnDocNo.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedReturnInvoice(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        goodsReturnInvoiceId:
          selectedReturnInvoice && selectedReturnInvoice.goodsReturnInvoiceId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approvegoodsreturninvoice/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const viewPdf = (id) => {
    setPdfView(true);

    if (id) {
      getGoodsReturnInvoice(
        {
          url: `/api/goodsReturnInvoice/?orgId=${localStorage.getItem(
            "orgId"
          )}&goodsReturnInvoiceId=${id}`,
        },
        (res) => {
          if (res) {
            setPdfData(res);
            console.log(res);
          }
        }
      );
    }
  };

  const printPdfContainer = () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide.forEach((element) => {
      element.style.display = "none !important";
    });
    document.body.style.overflow = "visible";

    window.print();
    document.body.style.overflow = "";
    elementsToHide.forEach((element) => {
      element.style.display = "";
    });
  };

  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "Goods Return Invoice";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  return (
    <>
      <AntModal
        title="Goods Return Invoice Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Goods Return Invoice</label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Return Invoice
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered table-responsive">
                      <thead>
                        <tr>
                          <th>Order Date</th>
                          <th>Goods Return Invoice No </th>

                          <th>Goods Return No </th>

                          <th>Purchase Order No</th>

                          <th>Goods Receipt No </th>
                          <th>Purchase Invoice No</th>
                          <th>Vendor Name</th>
                          <th>Total Return cost/Value</th>
                          <th>Currency </th>

                          <th>Assign Employee </th>
                          <th>Approve</th>
                          {/* {canView === "block" && <th>View</th>} */}

                          {canPdf === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.invoiceDate}</td>
                                <td>{itm.docNo}</td>

                                <td>{itm.grnDocNo}</td>
                                <td>{itm.poDocNo}</td>

                                <td>{itm.goodsReceiptNo}</td>
                                <td>{itm.piDocNo}</td>

                                <td>{itm.vendorName}</td>
                                <td>{itm.totalPurchaseAmount}</td>
                                <td>{itm.currencyName}</td>

                                <td>{itm.employeeName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {/* {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )} */}
                                {canPdf === "block" && (
                                  <td>
                                    {" "}
                                    <button
                                      className="btn"
                                      onClick={() =>
                                        viewPdf(itm.goodsReturnInvoiceId)
                                      }
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Goods Return Invoice Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row ">
              <p className="col-md-6">
                Goods Return Invoice No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Goods Return Invoice Date : {selectedData.invoiceDate}
              </p>
            </div>
            <div className="row ">
              <p className="col-md-6">
                Goods Return No: {selectedData.grnDocNo}
              </p>
            </div>
            <div className="row ">
              <p className="col-md-6">
                Purchase Invoice No: {selectedData.piDocNo}
              </p>
              <p className="col-md-6">
                Purchase Order No: {selectedData.poDocNo}
              </p>
            </div>

            <div className="row ">
              <p className="col-md-6">
                Goods Receipt No: {selectedData.goodsReceiptNo}
              </p>

              <p className="col-md-6">Vender Name: {selectedData.vendorName}</p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Condition Of Item: {selectedData.itemCondition}.
              </p>
              <p className="col-md-6">
                Reason Of Item: {selectedData.returnReason}.
              </p>
            </div>
            <hr />

            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Type</th>

                  <th>Rate</th>

                  <th>Return Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetails &&
                  selectedData.productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>

                        <td>{itm.rate}</td>

                        <td>{itm.goodsReturnQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.lineAmount}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="row">
              <p className="col-md-4">
                Sub-total Amount: {selectedData.lineTotalAmount}
              </p>
              <p className="col-md-4">
                Discount(%) : {selectedData.discountPercentage}
              </p>
              <p className="col-md-4">
                Discounted Amount: {selectedData.discountAmount}
              </p>
            </div>
            <div className="row">
              <p className="col-md-4">
                Total Amount: {selectedData.totalAmount}
              </p>
              <p className="col-md-4">Tax : {selectedData.taxName}</p>
              <p className="col-md-4">Tax Amount: {selectedData.taxAmount}</p>
            </div>
            <div className="row">
              <p className="col-md-4">
                frieght Charges: {selectedData.freightCharges}
              </p>
              <p className="col-md-4">
                Order Total Value : {selectedData.totalPurchaseAmount}
              </p>
              <p className="col-md-4">Currency: {selectedData.currencyName}</p>
            </div>
          </div>
        )}
      </Modal>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <br />
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  pdfData && pdfData.organizationIcon
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Goods Return Invoice
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{pdfData && pdfData.orgName}</strong>
                              <br />
                              {pdfData && pdfData.orgCity}{" "}
                              {pdfData && pdfData.orgState}
                              <br />
                              {pdfData && pdfData.orgCountry}{" "}
                              {pdfData && pdfData.orgzipCode}
                              <br />
                              Phone: {pdfData && pdfData.orgPhoneNumber}
                              <br />
                              Email: {pdfData && pdfData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.vendorName}</strong>
                              <br />
                              <p>
                                {pdfData && pdfData.vendorCity}{" "}
                                {pdfData && pdfData.vendorState}
                                <br />
                                {pdfData && pdfData.vendorCountry}{" "}
                                {pdfData && pdfData.vendorzipCode}
                                <br />
                                Phone: {pdfData && pdfData.vendorcontactWork}
                                <br />
                                Email: {pdfData && pdfData.vendoremail}
                              </p>
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Invoice Date:</b>{" "}
                            {pdfData && pdfData.invoiceDate}
                            <br />
                            <b>Return Invoice No:</b> {pdfData && pdfData.docNo}
                            <br />
                            <b>Goods Return No:</b>{" "}
                            {pdfData && pdfData.grnDocNo}
                            <br />
                            <b>Currency:</b> {pdfData && pdfData.currencyName}
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table  table-bordered">
                              <thead style={{ background: "#F0E9EA" }}>
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Item Category</th>
                                  <th>Item Description</th>
                                  <th>Item Unit Price</th>
                                  <th>Rate</th>
                                  <th>Return Quantity</th>
                                  <th>Unit</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.productDetails &&
                                  pdfData.productDetails.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>

                                        <td>{itm.productSubTypeName}</td>
                                        <td>{itm.productName}</td>
                                        <td>{itm.itemUnitPrice}</td>
                                        <td>{itm.rate}</td>
                                        <td>{itm.goodsReturnQuantity}</td>
                                        <td>{itm.unitAbbreviation}</td>
                                        <td>{itm.lineAmount}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Amount Chargeable:{" "}
                            </p>
                            <p> {pdfData && pdfData.amountChargeable}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}> Subtotal:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.lineTotalAmount}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Discount:(
                                      {pdfData && pdfData.discountPercentage}%)
                                    </th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.discountAmount}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      Tax Amount (
                                      {pdfData && pdfData.taxPercentage}%)
                                    </th>
                                    <td> {pdfData && pdfData.taxAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Frieght Charges :</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.freightCharges}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Total Cost:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.totalPurchaseAmount}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              {/* <button
                type="button"
                className="btn btn-default print-button"
                onClick={() => printPdfContainer()}
              >
                <i className="fas fa-print" /> Print
              </button> */}

              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.docNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default GoodsReturnInvoiceLisview;
